import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  titleViewCourseIn: {
    id: 'instructor.toolbar.view.course',
    defaultMessage: 'View course in:',
    description: 'Button to view the course in the studio',
  },
  titleStudio: {
    id: 'instructor.toolbar.studio',
    defaultMessage: 'Studio',
    description: 'Button to view in studio',
  },
  titleInsights: {
    id: 'instructor.toolbar.insights',
    defaultMessage: 'Insights',
    description: 'Button Insights',
  },
});

export default messages;
